import { getApis } from 'library/Apis';
import { toRequest } from 'utils/RequestUtils';
import { Dispatch } from 'redux';
import { AdendoAditivo, AdendoDistrato, CreateValueEntePublico, EditValueEntePublico } from './__types';
import moment from 'moment';
import SnackbarUtils from 'utils/SnackbarUtils';
import languageValues from 'utils/LanguageUtils';
import { AxiosError, AxiosResponse } from 'axios';

export const SET_CONTRATO_ID_ENTE_PUBLICO_ACTION = 'SET_CONTRATO_ID_ENTE_PUBLICO_ACTION';
export const CHANGED_CONTRATO_ENTE_PUBLICO_EDITING_VALUE_ACTION = 'CHANGED_CONTRATO_ENTE_PUBLICO_EDITING_VALUE_ACTION';
export const CLEAR_COD_COOP_ENTE_PUBLICO_ACTION = 'CLEAR_COD_COOP_ENTE_PUBLICO_ACTION';
export const CLEARED_CONTRATO_ENTE_PUBLICO_ACTION = 'CLEARED_CONTRATO_ENTE_PUBLICO_ACTION';
export const LOADED_CONTRATO_ENTE_PUBLICO_ACTION = 'LOADED_CONTRATO_ENTE_PUBLICO_ACTION';
export const CLEAR_CONTRATO_ENTE_PUBLICO_STATUS_GLOBAL_ACTION = 'CLEAR_CONTRATO_ENTE_PUBLICO_STATUS_GLOBAL_ACTION'
export const OPEN_MODAL_ENTE_PUBLICO_ADITIVO_ACTION = 'OPEN_MODAL_ENTE_PUBLICO_ADITIVO_ACTION'
export const OPEN_MODAL_ENTE_PUBLICO_DISTRATO_ACTION = 'OPEN_MODAL_ENTE_PUBLICO_DISTRATO_ACTION'
export const CLOSE_MODAL_ENTE_PUBLICO_ADITIVO_ACTION = 'CLOSE_MODAL_ENTE_PUBLICO_ADITIVO_ACTION'
export const CLOSE_MODAL_ENTE_PUBLICO_DISTRATO_ACTION = 'CLOSE_MODAL_ENTE_PUBLICO_DISTRATO_ACTION'


export const setContratoEntePublicoId = (id: number) => ({
  type: SET_CONTRATO_ID_ENTE_PUBLICO_ACTION,
  payload: id,
});

export const clearCodCoopEntePublicoGenericForm = () => ({
  type: CLEAR_COD_COOP_ENTE_PUBLICO_ACTION,
  payload: null,
});

export const clearContratoEntePublicoEditing = () => {
  return {
    type: CLEARED_CONTRATO_ENTE_PUBLICO_ACTION,
    payload: null,
  };
};

export const clearContratoStatusGlobal = () => {
  return {
    type: CLEAR_CONTRATO_ENTE_PUBLICO_STATUS_GLOBAL_ACTION,
  };
};

export const openModalEntePublicoAditivo = () => ({
  type: OPEN_MODAL_ENTE_PUBLICO_ADITIVO_ACTION,
});

export const closeModalEntePublicoAditivo = () => ({
  type: CLOSE_MODAL_ENTE_PUBLICO_ADITIVO_ACTION,
});

export const openModalEntePublicoDistrato = () => ({
  type: OPEN_MODAL_ENTE_PUBLICO_DISTRATO_ACTION,
});

export const closeModalEntePublicoDistrato = () => ({
  type: CLOSE_MODAL_ENTE_PUBLICO_DISTRATO_ACTION,
});

const getEndpoint = (version: number) => {
  return getApis().apis.contrato + 'v' + version;
};

export const changeContratoEntePublicoEditingValue = (name: string, value: string) => {
  let payloadValue = value;

  if (typeof value === 'string') {
    payloadValue = value.trim().length > 0 ? value : '';
  }

  return {
    type: CHANGED_CONTRATO_ENTE_PUBLICO_EDITING_VALUE_ACTION,
    payload: { name, value: payloadValue },
  };
};

export const contratoEntePublicoDescentralizadoRegisterPreEtapa = async (
  preEtapa: CreateValueEntePublico,
  dispatch: Dispatch
) => {
  const valoresPreEtapaFormatados = {
    ...preEtapa,
    dataInicio: moment(preEtapa.dataInicio, 'DD/MM/YYYY').format('YYYY-MM-DD'),
    dataFim: moment(preEtapa.dataFim, 'DD/MM/YYYY').format('YYYY-MM-DD'),
  };
  const resp = await toRequest('post', [
    `${getEndpoint(1)}/contrato/ente-publico/descentralizado`,
    valoresPreEtapaFormatados,
  ]);
  dispatch(setContratoEntePublicoId(resp.data.id));
  return resp;
};

export const loadContratoEntePublico = (
  id: number | null,
  versaoContrato: number
) => {
  return async (dispatch: Dispatch) => {
    try {
      const contratoResponse = await toRequest('get', [
        `${getEndpoint(
          1
        )}/contrato/ente-publico/descentralizado/${id}/${versaoContrato}`,
      ]);
      const contratoData = {
        ...contratoResponse.data,
        dataInicio: contratoResponse.data.dataInicio
          ? moment(contratoResponse.data.dataInicio, 'YYYY-MM-DD').format(
            'DD/MM/YYYY'
          )
          : '',
        dataFim: contratoResponse.data.dataFim
          ? moment(contratoResponse.data.dataFim, 'YYYY-MM-DD').format(
            'DD/MM/YYYY'
          )
          : '',
        dataDistrato: contratoResponse.data.dataDistrato
          ? moment(contratoResponse.data.dataDistrato, 'YYYY-MM-DD').format(
            'DD/MM/YYYY'
          )
          : '',
      };
      dispatch({
        type: LOADED_CONTRATO_ENTE_PUBLICO_ACTION,
        payload: contratoData,
      });
    } catch (error) {
      SnackbarUtils.enqueueSnackbar({
        message:
          error ||
          languageValues.toasts.error
            .carregarContratosEntePublicoDescentralizado,
        options: {
          variant: 'error',
        },
      });
    }
  };
};

export const contratoEntePublicoDescentralizadoEdit = async (
  idContrato: number,
  preEtapaEdit: EditValueEntePublico,
  dispatch: Dispatch
) => {
  const valoresPreEtapaEditFormatados = {
    ...preEtapaEdit,
    dataInicio: moment(preEtapaEdit.dataInicio, 'DD/MM/YYYY').format('YYYY-MM-DD'),
    dataFim: moment(preEtapaEdit.dataFim, 'DD/MM/YYYY').format('YYYY-MM-DD')
  }
  const resp = await toRequest('put', [
    `${getEndpoint(1)}/contrato/ente-publico/descentralizado/${idContrato}`,
    valoresPreEtapaEditFormatados,
  ]);
  dispatch(setContratoEntePublicoId(resp.data.id));
  return resp;
};

export const contratoEntePublicoDescentralizadoCreateAditivo = (
  aditivo: AdendoAditivo,
  callbackSuccess: (response: AxiosResponse) => void,
  callbackError: (error: AxiosError) => void
) => {
  return async () => {
    try {
      const resp = await toRequest('post', [
        `${getEndpoint(1)}/contrato/ente-publico/descentralizado/aditivo`,
        aditivo,
      ]);
      if (typeof callbackSuccess === 'function') {
        callbackSuccess(resp);
      }
    } catch (error) {
      if (typeof callbackError === 'function') {
        callbackError(error as AxiosError);
      }
    }
  };
};

export const contratoEntePublicoDescentralizadoEditAditivo = (
  idAditivo: number | null,
  aditivo: AdendoAditivo,
  callbackSuccess: (response: AxiosResponse) => void,
  callbackError: (error: AxiosError) => void
) => {
  return async () => {
    try {
      const resp = await toRequest('put', [
        `${getEndpoint(
          1
        )}/contrato/ente-publico/descentralizado/aditivo/${idAditivo}`,
        aditivo,
      ]);
      if (typeof callbackSuccess === 'function') {
        callbackSuccess(resp);
      }
    } catch (error) {
      if (typeof callbackError === 'function') {
        callbackError(error as AxiosError);
      }
    }
  };
};

export const contratoEntePublicoDescentralizadoCreateDistrato = (
  distrato: AdendoDistrato,
  callbackSuccess: (response: AxiosResponse) => void,
  callbackError: (error: AxiosError) => void
) => {
  return async () => {
    try {
      const resp = await toRequest('post', [
        `${getEndpoint(1)}/contrato/ente-publico/descentralizado/distrato`,
        distrato,
      ]);
      if (typeof callbackSuccess === 'function') {
        callbackSuccess(resp);
      }
    } catch (error) {
      if (typeof callbackError === 'function') {
        callbackError(error as AxiosError);
      }
    }
  };
};

export const contratoEntePublicoDescentralizadoEditDistrato = (
  idDistrato: number | null,
  distrato: AdendoDistrato,
  callbackSuccess: (response: AxiosResponse) => void,
  callbackError: (error: AxiosError) => void
) => {
  return async () => {
    try {
      const resp = await toRequest('put', [
        `${getEndpoint(
          1
        )}/contrato/ente-publico/descentralizado/distrato/${idDistrato}`,
        distrato,
      ]);
      if (typeof callbackSuccess === 'function') {
        callbackSuccess(resp);
      }
    } catch (error) {
      if (typeof callbackError === 'function') {
        callbackError(error as AxiosError);
      }
    }
  };
};